<template>
    <div class="slot-picker">

        <p v-if="bookDate" class="w-100">
            Chosen date: {{ bookDate | longDate }}
        </p>

        <div class="d-flex flex-column flex-lg-row">
            <v-date-picker v-model="bookDate" @update:from-page="pageChange" :available-dates="bookableDates"></v-date-picker>

            <div class="choices-wrapper">
                <p class="small my-2">Filter available days using time of day:</p>
                <div class="d-flex align-items-center flex-wrap">
                    <button type="button" class="btn btn-sm btn-tertiary gold mr-3 mb-3" :class="{ active: filterMorning }"
                        v-on:click="filterMorning = !filterMorning; applyFilters();">
                        Morning
                    </button>
                    <button type="button" class="btn btn-sm btn-tertiary gold mr-3 mb-3" :class="{ active: filterAfternoon }"
                        v-on:click="filterAfternoon = !filterAfternoon; applyFilters();">
                        Afternoon
                    </button>
                    <button type="button" class="btn btn-sm btn-tertiary gold mr-3 mb-3" :class="{ active: filterEvening }"
                        v-on:click="filterEvening = !filterEvening; applyFilters();">
                        Evening
                    </button>
                </div>
                <div v-if="bookableDateSlots" class="my-3 timeslots">
                    <h5>Please select a fitting time:</h5>
                    <div class="d-flex align-items-center flex-wrap">
                        <button v-for="(bookableDateSlot, idx) in bookableDateSlots" :key="idx" type="button"
                            class="btn btn-tertiary gold mr-3 mb-3" :value="bookableDateSlot.start_at" :id="'slot-' + idx"
                            v-on:click="slotSelected">
                            {{ bookableDateSlot.start_time }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            bookDate: null,
            bookableDates: [],
            bookableDateSlots: null,
            slots: [],
            filterMorning: false,
            filterAfternoon: false,
            filterEvening: false,
            activeBranchId: null
        };
    },

    props: [
        'schoolId',
        'branchId',
        'maleOverrideBranchId',
        'femaleOverrideBranchId',
        'gender'
    ],

    watch: {
        bookDate: function (val) {
            if (val !== null) {
                var selectedDate = val.toLocaleDateString('en-CA'); // weird, but works
                this.bookableDateSlots = this.slots[selectedDate];
            }

            const event = new Event('change');
            const startsAt = document.querySelector("input#start_at");
            startsAt.dispatchEvent(event);
        },
    },

    mounted() {
        // const calendar = this.$refs.calendar;
    },

    methods: {
        applyFilters() {
            document.querySelector("input#start_at").value = '';

            const triggerChange = new Event('change');
            document.querySelector("input#start_at").dispatchEvent(triggerChange);

            const timeslots = document.querySelector('.timeslots');
            if(timeslots) {
                timeslots.querySelector('button').classList.remove('active');
            }
            this.getData();
        },
        getData() {
            if(this.gender !== null) {
                this.activeBranchId = this.branchId;

                if (this.maleOverrideBranchId && this.gender == 'm' ) {
                    this.activeBranchId = this.maleOverrideBranchId;
                }

                if (this.femaleOverrideBranchId && this.gender == 'f') {
                    this.activeBranchId = this.femaleOverrideBranchId;
                }

                axios.post('/api/v1/appointments/' + this.activeBranchId + '/slots', {
                    school_id: this.schoolId,
                    year: this.year,
                    month: this.month,
                    filter_morning: this.filterMorning,
                    filter_afternoon: this.filterAfternoon,
                    filter_evening: this.filterEvening
                })
                    .then(res => {
                        if (res.data && res.data.success) {
                            var availableSlots = Object.keys(res.data.slots);
                            if (availableSlots.length > 0) {
                                this.bookableDates = availableSlots;
                                this.slots = res.data.slots;
                                if (this.bookDate !== null) {
                                    var selectedDate = this.bookDate.toLocaleDateString('en-CA'); // weird, but works
                                    if (typeof this.slots[selectedDate] === 'undefined') {
                                        this.bookDate = null;
                                        this.bookableDateSlots = null;
                                    } else {
                                        this.bookableDateSlots = this.slots[selectedDate];
                                    }
                                }

                            } else {
                                // bit hacky but seems to work
                                this.bookableDates = ['1980-06-03'];
                                this.slots = null;
                                this.bookableDateSlots = null;
                                this.bookDate = null;
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },
        pageChange(event) {
            document.querySelector("input#start_at").value = '';

            const triggerChange = new Event('change');
            document.querySelector("input#start_at").dispatchEvent(triggerChange);

            this.bookableDateSlots = null;
            this.bookDate = null;
            this.year = event.year;
            this.month = event.month;
            this.getData();
        },
        slotSelected(event) {
            document.querySelectorAll(".timeslots button").forEach(el => {
                el.classList.remove('active');
            });
            document.querySelector(".timeslots button#" + event.target.id).classList.add("active");
            document.querySelector("input#start_at").value = event.target.value;

            const triggerChange = new Event('change');
            document.querySelector("input#start_at").dispatchEvent(triggerChange);

            if (this.activeBranchId != this.branchId) {
                document.querySelector("input#override_branch_id").value = this.activeBranchId;
                document.querySelector("input#override_branch_id").dispatchEvent(triggerChange);
            } else {
                document.querySelector("input#override_branch_id").value = '';
                document.querySelector("input#override_branch_id").dispatchEvent(triggerChange);
            }
        }
    }
};
</script>
